<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-5">
  <div class="w-full max-w-sm text-center">

    <!-- Illustration -->
    <div class="relative mb-8 flex justify-center">
      <div class="w-40 h-40 rounded-full bg-blue-100 flex items-center justify-center">
        <div class="w-28 h-28 rounded-full bg-blue-200/60 flex items-center justify-center">
          <span class="material-symbols-outlined text-blue-400" style="font-size:3.5rem">search_off</span>
        </div>
      </div>
      <!-- Floating badge -->
      <div class="absolute -top-1 -right-4 w-12 h-12 rounded-2xl bg-white shadow-lg border border-slate-100 flex items-center justify-center rotate-12">
        <span class="material-symbols-outlined text-red-400" style="font-size:1.4rem">error</span>
      </div>
      <div class="absolute -bottom-2 -left-2 w-9 h-9 rounded-xl bg-white shadow-md border border-slate-100 flex items-center justify-center -rotate-6">
        <span class="material-symbols-outlined text-amber-400" style="font-size:1.1rem">hotel</span>
      </div>
    </div>

    <!-- 404 text -->
    <div class="text-[72px] font-black text-blue-600/20 leading-none tracking-tighter mb-2 select-none">404</div>

    <!-- Message -->
    <h1 class="text-xl font-black text-slate-800 mb-2 tracking-tight">{{ 'ไม่พบหน้าที่คุณต้องการ' | translate : 'not-found' }}</h1>
    <p class="text-[14px] text-slate-500 font-medium leading-relaxed mb-8">
      {{ 'ลิงก์นี้อาจถูกลบ หมดอายุ หรือไม่มีอยู่ในระบบ' | translate : 'not-found' }}<br>{{ 'กรุณาตรวจสอบ URL อีกครั้ง' | translate : 'not-found' }}
    </p>
  </div>
</div>
